import { Sentence } from './sentence';
import { Language } from './language';
import { hasDecimalPlaceBetween } from '../helpers/numberHelpers';

/**
 * Sentence that gets displayed in the listener view
 */
export class DisplaySentence {
  id: string;
  order: number;
  creation: string;
  isComplete: boolean;
  text: string;
  textDirection: string;
  speakerId: string;
  colorOverride: string;

  public get isInsertedSentence(): boolean {
    return hasDecimalPlaceBetween(this.order, 3, 5);
  }

  constructor(sentence: Sentence, language: Language) {
    this.id = sentence.id;
    this.order = sentence.order;
    this.creation = sentence.creation;
    this.isComplete = sentence.isComplete;
    this.text = sentence.text;
    this.textDirection = sentence.textDirection;
    this.speakerId = sentence.speakerId;

    // Override speaker color, if speaker is detected
    // To generate different color for different events, we use the event id as well
    if (sentence.speakerId && sentence.speakerId !== 'Unknown') {
      this.colorOverride = this.getColorForSpeaker(sentence.eventId, sentence.speakerId);
    } else {
      this.colorOverride = null;
    }

    if (language) {
      // Translation has been requested.
      // We use the text direction from the translation language.
      this.textDirection = language.direction;

      // 1. Check, if the requested translation language is the same as the recording language
      // If so, just return the original text.
      if (language.code === sentence.language) {
        return;
      }

      // 2. Check, if a translation for the requested language is available. If so, we use the
      // text from the translations and the direction from the language.
      if (sentence.translations) {
        // Allow for both uppercase and lowercase language codes (legacy technical debt)
        const translation = sentence.translations[language.code] || sentence.translations[language.code.toLowerCase()];
        this.text = translation || '';
        return;
      }

      // 3. If no translation is available, we display no text.
      this.text = '';
    }
  }

  private getColorForSpeaker(eventId: string, speakerId: string): string {
    const colors = [
      '#C00000',
      '#FF0000',
      '#FFC000',
      '#FFFF00',
      '#92D050',
      '#00B050',
      '#00B0F0',
      '#0070C0',
      '#002060',
      '#7030A0'
    ];

    // Create a unique hash value based on the combination of eventId and speakerId.
    const hash = `${eventId}_${speakerId}`.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    return colors[hash % colors.length];
  }
}
